import { useEffect } from 'react';
import type { FormOrPacketToSend } from '@frontend/form-packet-selector';
import { useSendFormsStore } from '../store';

interface UseDocumentToSendConfigProps {
  documentToSend: FormOrPacketToSend | null;
}

const useDocumentToSendConfig = ({ documentToSend }: UseDocumentToSendConfigProps) => {
  const { setFormOrPacketToSend } = useSendFormsStore(['setFormOrPacketToSend']);

  useEffect(() => {
    if (documentToSend) {
      setFormOrPacketToSend(documentToSend);
    }
  }, [documentToSend]);
};

export default useDocumentToSendConfig;
